module.exports = __webpack_public_path__ + "img/E001_R_home slider.1449af31.jpg";